module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House46.f3317c7d.jpg";